// extracted by mini-css-extract-plugin
export const oneTimeBox = "one-day-module--oneTimeBox--3I7CY";
export const oneDayContainer = "one-day-module--oneDayContainer--1Brac";
export const date = "one-day-module--date--2aE2H";
export const tooltip = "one-day-module--tooltip--qZAiA";
export const tooltiptext = "one-day-module--tooltiptext--3N0A9";